<template>
  <Form ref="sysDictTypeForm" :model="sysDictType" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="sysDictType.id" type="hidden"/>

    <FormItem  :label="this.$t('common.sys-dict-typ.sign.label')" prop="sign">
      <Input v-model="sysDictType.sign" :placeholder="$t('common.sys-dict-typ.sign.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('common.sys-dict-typ.label.label')" prop="label">
      <Input v-model="sysDictType.label" :placeholder="$t('common.sys-dict-typ.label.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('common.sys-dict-typ.status.label')" prop="status">
      <Select v-model="sysDictType.status" :placeholder="$t('common.sys-dict-typ.status.holder')">
        <Option v-for="item in $t('common.sys-dict-typ.status.dictionary')" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
    </FormItem>

    <FormItem  :label="this.$t('common.sys-dict-typ.remark.label')" prop="remark">
      <Input v-model="sysDictType.remark" :placeholder="$t('common.sys-dict-typ.remark.holder')"  type="textarea" :rows="3"/>
    </FormItem>

  </Form>
</template>
<script>
import api from '@/api'

export default {
  data () {
    return {
      sysDictType: {
        id: null,
        sign: null,
        label: null,
        status: 1,
        remark: null,
        createTime: null,
        updateTime: null,
        deleted: 0
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    handleSubmit(then,error){
      this.$refs['sysDictTypeForm'].validate(valid => {
        if (valid) {
          if (this.sysDictType.id) {
            this.updateSysDictType(this.sysDictType).then(then).error(error)
          } else {
            this.createSysDictType(this.sysDictType).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.sysDictType.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['sysDictTypeForm'].resetFields());
    },
    getSysDictType(id,type){
      this.loading = true;
      this.$refs['sysDictTypeForm'].resetFields()
      api.common.SysDictType.detail(id).then(data => {
        this.sysDictType = data;
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createSysDictType(sysDictType){
      this.loading = true;
      return api.common.SysDictType.add(sysDictType)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateSysDictType(sysDictType){
      this.loading = true;
      return api.common.SysDictType.update(sysDictType)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      sign: [{type: 'string', required: true, message: this.$t('common.sys-dict-typ.sign.required'),trigger: 'blur'}, {type: 'string',max: 100, message: this.$t('common.sys-dict-typ.sign.max'),trigger: 'blur'}],
      label: [{type: 'string', required: true, message: this.$t('common.sys-dict-typ.label.required'),trigger: 'blur'}, {type: 'string',max: 100, message: this.$t('common.sys-dict-typ.label.max'),trigger: 'blur'}],
      status: [{type: 'number', required: true, message: this.$t('common.sys-dict-typ.status.required'),trigger: 'blur'}],
      remark: [{type: 'string',max: 500, message: this.$t('common.sys-dict-typ.remark.max'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['sysDictTypeForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
